import { render, staticRenderFns } from "./BadgeCellRendererPromotion.vue?vue&type=template&id=68d25df4"
import script from "./BadgeCellRendererPromotion.vue?vue&type=script&lang=js"
export * from "./BadgeCellRendererPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports